<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="showSidemenu"
      app
    >
      <Sidemenu />
    </v-navigation-drawer>

    <v-app-bar app flat collapse color="white">
      <v-app-bar-nav-icon @click="showSidemenu = !showSidemenu"></v-app-bar-nav-icon>

      <!-- <v-toolbar-title>GPX Token</v-toolbar-title> -->
    </v-app-bar>

    <v-main class="gradient-color" >
      <v-container fluid>
        <Snackbar />
        <router-view ></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Sidemenu from "@/layouts/Sidemenu.vue";
import Snackbar from '@/components/Snackbar'

export default {
  name: 'Layout',
  components: {
    Sidemenu,
    Snackbar
  },
  data: () => ({
    showSidemenu: true,
  }),
};
</script>
